import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Wheelchair = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="wheelchair"
      width={width}
      height={height}
      fill={fill}
      stroke="none"
      className={className}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.9918 5.73014C13.2967 5.73014 14.3568 4.67126 14.3568 3.3651C14.3568 2.05854 13.2967 1 11.9918 1C10.6854 1 9.62622 2.05854 9.62622 3.3651C9.62622 4.67126 10.6854 5.73014 11.9918 5.73014Z" />
      <path d="M15.6464 19.132C15.018 21.3142 13.0063 22.9167 10.6244 22.9167C7.74009 22.9167 5.39446 20.571 5.39446 17.6876C5.39446 15.5531 6.68213 13.716 8.51979 12.9042V10.6873C5.51037 11.5938 3.31152 14.3873 3.31152 17.6876C3.31152 21.7194 6.59203 25 10.6244 25C13.563 25 16.0958 23.2535 17.2572 20.7476L16.4315 19.1253C16.1997 19.1272 15.9312 19.1297 15.6464 19.132Z" />
      <path d="M22.537 21.9395L19.3691 15.7112C19.1326 15.2452 18.6546 14.9519 18.1318 14.9519H14.0744V14.0267H17.5663C17.915 14.0267 18.2081 13.8444 18.3975 13.5819C18.5205 13.4108 18.608 13.2121 18.608 12.9849C18.608 12.4098 18.1422 11.9434 17.5663 11.9434H15.4626H14.0744V8.80527C14.0744 7.94221 13.4344 6.72205 11.9919 6.72205C10.8414 6.72205 9.90869 7.65487 9.90869 8.80527V15.6043C9.90869 16.7779 10.8601 17.7293 12.0338 17.7293H15.8518H17.2803L20.0621 23.1987C20.3066 23.6804 20.7944 23.9584 21.3007 23.9584C21.5129 23.9584 21.7281 23.9099 21.9292 23.807C22.6138 23.4597 22.8857 22.6231 22.537 21.9395Z" />
    </svg>
  );
};
/* eslint-enable max-len */

Wheelchair.defaultProps = {
  className: null,
};

Wheelchair.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Wheelchair;
